import { useState } from "react";
import { Col, Row } from "reactstrap";
import { timeSlots } from "../../../utils/dashTime";

export const TimeSlots = ({
  startDate,
  endDate,
  onSelect,
  selStartIndex,
  selEndIndex,
  selectedDateTimeDisplay,
}) => {
  const [isStartHovered, setIsStartHovered] = useState(null);
  const [isEndHovered, setIsEndHovered] = useState(null);


  const nowInJapan = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
  );

  nowInJapan.setMinutes(nowInJapan.getMinutes() - 1);

  const isFutureSlot = (date, timeStr) => {
    if (!date) return true;
    const [hours, minutes] = timeStr.split(":").map(Number);

    const slotDate = new Date(
      `${date}T${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:00`
    );

    return slotDate > nowInJapan;
  };

  const handleSelect = (type, date, time, index) => {
    if (isFutureSlot(date, time)) return;
    if (onSelect) onSelect({ date, type, time }, index);
  };

  const firstDisabledStartIndex = timeSlots.findIndex((time) =>
    isFutureSlot(startDate, time)
  );
  const firstDisabledEndIndex = timeSlots.findIndex((time) =>
    isFutureSlot(endDate, time)
  );

  const highlightStartIndex = (() => {
    if (selStartIndex == null && selEndIndex == null) {
      return firstDisabledStartIndex > 0 ? firstDisabledStartIndex - 1 : null;
    }
    return null;
  })();

  const highlightEndIndex = (() => {
    if (selStartIndex == null && selEndIndex == null) {
      if (firstDisabledEndIndex === -1) {
        return timeSlots.length - 1;
      } else if (firstDisabledEndIndex > 0) {
        return firstDisabledEndIndex - 1;
      }
      return null;
    }
    return null;
  })();

  return (
    <div className="d-flex flex-column timeMenu">
      {timeSlots.map((time, index) => {
        const startDisabled = isFutureSlot(startDate, time);
        const endDisabled = isFutureSlot(endDate, time);

        const slotStartDateTime = `${startDate} ${time}`;
        const isSelectedStartSlot =
          slotStartDateTime === selectedDateTimeDisplay;

        const slotEndDateTime = `${endDate} ${time}`;
        const isSelectedEndSlot = slotEndDateTime === selectedDateTimeDisplay;

        return (
          <Row
            key={index}
            className="align-items-center justify-content-between border slot-item mx-0 flex-nowrap"
          >
            {/* START SLOT */}
            <Col
              xs={6}
              className={`d-flex pointerDiv text-nowrap border-end      
                          ${startDisabled ? "disabled-slot" : ""}
                           ${isSelectedStartSlot ? "selected-slot" : ""}
                        `}
              style={{
                whiteSpace: "nowrap",
                minWidth: 0,
                borderRight: "1px solid #ccc",
                cursor: startDisabled ? "not-allowed" : "pointer",
              }}
              onClick={() =>
                !startDisabled &&
                startDate &&
                handleSelect("start", startDate, time, index)
              }
            >
              <div
                onMouseEnter={() => setIsStartHovered(index)}
                onMouseLeave={() => setIsStartHovered(null)}
                className="d-flex align-items-center gap-1 py-1"
                style={{ whiteSpace: "nowrap" }}
              >
                <img
                  src={
                    isStartHovered === index || isSelectedStartSlot
                      ? "./calendar2.png"
                      : "./Calendar.png"
                  }
                  alt="calendar"
                  className="icon"
                />
                <span className="dateSize">{startDate}</span>
                <img
                  src={
                    isStartHovered === index || isSelectedStartSlot
                      ? "./Clock1.png"
                      : "./Clock.png"
                  }
                  alt="clock"
                  className="icon ms-3"
                />
                <span className="dateSize pe-2">{time}</span>
              </div>
            </Col>

            {/* END SLOT */}
            <Col
              xs={6}
              className={`d-flex pointerDiv text-nowrap 
                ${endDisabled ? "disabled-slot" : ""}
             ${isSelectedEndSlot ? "selected-slot" : ""}
               `}
              style={{
                whiteSpace: "nowrap",
                minWidth: 0,
                cursor: endDisabled ? "not-allowed" : "pointer",
              }}
              onClick={() =>
                !endDisabled &&
                endDate &&
                handleSelect("end", endDate, time, index)
              }
            >
              <div
                onMouseEnter={() => setIsEndHovered(index)}
                onMouseLeave={() => setIsEndHovered(null)}
                className="d-flex align-items-center gap-1 py-1"
                style={{ whiteSpace: "nowrap" }}
              >
                <img
                  src={
                    isEndHovered === index || isSelectedEndSlot
                      ? "./calendar2.png"
                      : "./Calendar.png"
                  }
                  alt="calendar"
                  className="icon"
                />
                <span className="dateSize">{endDate}</span>
                <img
                  src={
                    isEndHovered === index || isSelectedEndSlot
                      ? "./Clock1.png"
                      : "./Clock.png"
                  }
                  alt="clock"
                  className="icon ms-3"
                />
                <span className="dateSize pe-2">{time}</span>
              </div>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};
